import { render, staticRenderFns } from "./liveLabel.vue?vue&type=template&id=168eb1b8&scoped=true"
import script from "./liveLabel.vue?vue&type=script&lang=js"
export * from "./liveLabel.vue?vue&type=script&lang=js"
import style0 from "./liveLabel.vue?vue&type=style&index=0&id=168eb1b8&prod&lang=less&scoped=true"
import style1 from "./liveLabel.vue?vue&type=style&index=1&id=168eb1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168eb1b8",
  null
  
)

export default component.exports